import React from "react";
import { format, parseISO } from "date-fns";
import {
  SessionSummary,
  formatDurationLong,
} from "../../../helpers/analyticsPlusJourney";

interface SessionListProps {
  sessions: SessionSummary[];
  selectedId: string | null;
  onSelect: (sessionId: string) => void;
}

export const SessionList: React.FC<SessionListProps> = ({
  sessions,
  selectedId,
  onSelect,
}) => (
  <ul className="flex flex-col">
    {sessions.map((session) => {
      const isSelected = session.sessionId === selectedId;
      return (
        <li key={session.sessionId}>
          <button
            onClick={() => onSelect(session.sessionId)}
            className={`w-full text-left px-3 py-3 border-l-2 ${
              isSelected
                ? "border-primary bg-primary/5"
                : "border-transparent hover:bg-gray-50"
            }`}
          >
            <div className="flex items-baseline justify-between gap-2">
              <span className="text-sm font-medium text-gray-800">
                {format(parseISO(session.start), "MMM d, HH:mm")}
              </span>
              <span className="text-xs text-gray-400">
                {formatDurationLong(session.durationSeconds)}
              </span>
            </div>
            <div className="text-xs text-gray-500 mt-0.5">
              {session.eventCount} event{session.eventCount > 1 ? "s" : ""}
              {session.bounce && " · bounce"}
            </div>
            <div className="text-xs text-gray-600 mt-1 truncate">{session.oneLine}</div>
          </button>
        </li>
      );
    })}
  </ul>
);
